import Styles from './index.module.scss'
import lion from '../imgs/lion.png'
import React, {useEffect, useMemo, useRef, useState} from "react";
import SyntheticConfirmModal from "../components/syntheticConfirmModal";
import ShareModal from "../components/shareModal";
import OpenAppFooter from "../components/openAppFooter";
import Service from "../service";
import Library from "../../../../library";
import NFTModal from "../../womenDay/components/NFTModal";
import GetFragmentsModal from "../components/getFragmentsModal";
import {Toast} from "antd-mobile";
import RulesModal from "../components/rulesModal";
/**
 * @description 邀新得碎片，合成藏品
 * @return {/front/activities/fragmentsSynthetic}
 */
const { JsBridge, Platform } = Library;
const isMiniprogram = Platform.check.isMiniprogram()

const Home = (props) => {
  const {clientId, openId, inviteId} = Library.Util.url.paramsToObj();
  const pageDom = useRef(null);
  const [userInfo, setUserInfo] = useState({});
  const [userInfoVerify, setUserInfoVerify] = useState({})
  const [data, setData] = useState({});
  const [popVisable, setPopVisable] = useState(false);

  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }
    return msg;
  }, [data]);

  useEffect(() => {
    (()=>{
      getData(true, true);
      onDidFocus();
    })()

  }, []);
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false, isFirst = false ) => {
    const userInfoRes = await JsBridge.getDetailCurrentUserInfo()
    if(!userInfoRes.isLogin && !isMiniprogram) {
      JsBridge.goLogin().then();
      return;
    }
    setUserInfoVerify(userInfoRes)
    const userInfo = await JsBridge.getCurrentUserInfo();
    setUserInfo(userInfo)
    console.log(userInfo)
    const result = await Service.getInitData(
      {
        clientId: isMiniprogram ? clientId : userInfo?.clientId,
        miniOpenId: isMiniprogram && openId && openId !== 'undefined' && openId !== 'null' ? openId : null,
        inviteId: isMiniprogram && inviteId && inviteId !== 'undefined' && inviteId !== 'null' ? inviteId : null,
      },
      loading,
    );
    if (result?.data) {
      setData(result.data)
      if(result.data.isFirst === 1 && isMiniprogram && isFirst) {
        handleGetFragments()
      }
    }
  }
  const handleSynthetic = () => {
    if (isMiniprogram) {
      setPopVisable(true)
      return
    }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfoVerify?.ID) {
      return Toast.show('请先实名认证')
    }
    const ModalInstance = NFTModal.show({
      content: <SyntheticConfirmModal
        onClose={() => ModalInstance?.close()}
        successCallBack={() => {
          getData(true, false)
        }}
        clientId={userInfo?.clientId}
      />,
      getContainer: pageDom.current,
    });
  }
  const handleShare = () => {
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    const ModalInstance = NFTModal.show({
      content: <ShareModal
        onClose={() => ModalInstance?.close()}
      />,
      getContainer: pageDom.current,
      closeOnMaskClick: true,
    });
  }
  const handleGetFragments = async () => {
    const result = await Service.getFragmentsService(
      {
        clientId,
        miniOpenId: openId,
      },
      true,
    );
    if (result?.data?.parts) {
      const ModalInstance = NFTModal.show({
        content: <GetFragmentsModal
          onClose={() => ModalInstance?.close()}
          successCallBack={() => {
            getData(true, false)
          }}
          data={result.data.parts}
        />,
        getContainer: pageDom.current,
      });
    }
  }
  const toSyntheticList = () => {
    const uri = '/front/activities/fragmentsSynthetic/syntheticList'
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${uri}` })
    } else {
      props.history.push(uri)
    }
  }
  const handleShareForMini = () => {
    window.JsBridge.miniNavigateTo(`/pages/activitys/fragmentsByInvite/share?inviteCode=${clientId}`)
  }
  const toVerifyName = () => {
    window.JsBridge.verifyRealName('合成数字藏品，请提前完成实名认证。').then((res) => {
    });
  }
  const ruleClick = () => {
    RulesModal.open({
      btnStyle: {
        background: 'linear-gradient(99deg, #D4BA77 4%, #FFEAB4 98%)',
        color: '#624C16'
      },
      activityCode: Service.activityCode,
      codeType: "activityRule",
      code: Service.activityCode,
    });
  }
  return (
    <div className={Styles.fragmentsHome} ref={pageDom}>
      {!isMiniprogram && <div className={Styles.backBox} onClick={() => window.JsBridge.back()}/>}
      <div className={Styles.bannerBox}>
        <div className={Styles.headImg}>
          <div className={Styles.imgDiv}/>
        </div>
        <div className={Styles.ruleBtn} onClick={ruleClick}>活动规则 ></div>
        {!isMiniprogram && !userInfoVerify?.ID && <div className={Styles.verifyNameBtn} onClick={toVerifyName}>实名认证 ></div>}
      </div>
      {/*<div className={Styles.centerText}>前 x 名可得 xxx</div>*/}
      <div className={Styles.contentBox}>
        <div className={Styles.haveFragments}>
          <div className={Styles.haveText}>当前持有碎片</div>
          {isMiniprogram ? <button disabled={!(data?.drawCount > 0)} className={Styles.getFragmentsBtn} onClick={handleGetFragments}>抽碎片({data?.drawCount})</button> : <button disabled={tipsMessage} className={Styles.shareBtn} onClick={handleShare}>去分享</button>}
        </div>
        <div className={Styles.fragmentsImgBox}>
          {data?.list?.length > 0 && data.list.map((item, index) => {
            return (
              <div key={index} className={Styles.fragmentsImg}>
                <img src={item.imgUrl} alt="" style={{ filter: item?.count > 0 ? '' : 'grayscale(100%)'}}/>
                <div className={Styles.numTag}>{item?.count || 0}</div>
              </div>
            )
          })}
        </div>
        {isMiniprogram && <div className={Styles.shareBtnForMini}>
          <button onClick={handleShareForMini}>分享邀新得碎片</button>
        </div>}
        <div className={Styles.syntheticText}>
          <div className={Styles.text}>合成藏品</div>
          {!isMiniprogram && <button className={Styles.toListBtn} onClick={toSyntheticList}>合成记录></button>}
        </div>
        <div className={Styles.syntheticOperateBox}>
          <img className={Styles.leftImg} src={lion} alt=""/>
          <div className={Styles.rightBox}>
            <div className={Styles.text2}>当前可合成 <span className={Styles.text3}>{data?.canSynthesis || 0}</span></div>
            <button disabled={!(data?.canSynthesis > 0) || tipsMessage} onClick={handleSynthetic}>去合成</button>
          </div>
        </div>
      </div>
      <OpenAppFooter
        visible={popVisable}
        onClose={() => setPopVisable(false)}
        dowonloadUrl={'https://app.gkewang.com/app'}
      />
    </div>
  )
}
export default Home
